// Тестовый файл для проверки загрузки конфигурации
import config from './config';

console.log('=== Тест конфигурации ===');
console.log('Config загружен:', !!config);
console.log('API URL:', config?.api?.baseURL);
console.log('Token Key:', config?.auth?.tokenKey);
console.log('Login Route:', config?.app?.loginRoute);
console.log('========================');
